import { TextField, Button, FormControl, Grid, InputAdornment, IconButton } from '@mui/material';

import { CustomAutocomplete, LinearLoading } from 'common'
import { Send } from 'react-feather';

export const ManagementLogForm = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        Actions
    } = useFetchInit

    const { LogsForm } = Forms
    const { formState, onInputChange } = LogsForm
    
    const { onSubmitLog, handleClickResetLogForm } = Actions

    return (
        <>
        
            <div className='h4 mt-1 mb-1'>
                {formState.idlawyerlogs > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>

            <div className="pt-2"></div>
            <form onSubmit={onSubmitLog}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="descripcion">Descripción</label>
                            <TextField
                                id='descripcion'
                                name='descripcion'
                                value={ formState.descripcion } 
                                onChange={onInputChange}
                                size='small'
                                placeholder=''
                                type='text'
                                multiline
                                rows={4}
                                variant={readOnlyMode? 'filled': 'outlined'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="send message"
                                                type="submit"
                                            >
                                                <Send />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    readOnly: readOnlyMode
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                {/* <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button
                                style={{background: "#4b4b4c"}}
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                            </Button>
                            &nbsp; &nbsp;
                            <Button 
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                type="button"
                                variant="contained"
                                onClick={handleClickResetLogForm}
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                            </Button>
                        </div>
                    </Grid>
                </Grid> */}
            </form>
        </>
    )
}
